import { render, staticRenderFns } from "./CurrentPlans.vue?vue&type=template&id=c71acbf2"
import script from "./CurrentPlans.vue?vue&type=script&lang=js"
export * from "./CurrentPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports